<div class="current" *ngIf="price !== 0 && !item?.priceOnRequest">
  {{ price | currency }}
  <ng-container *ngIf="pricePer === 1">{{ item?.unit }}</ng-container>
  <ng-container *ngIf="pricePer !== 1"> per {{ pricePer | number }}</ng-container>
</div>
<div class="was" *ngIf="wasPrice">
  &nbsp;was&nbsp;<span>{{ wasPrice | currency }}</span>
</div>
